export default {

	objectPick(object, keys) {
		return Object.fromEntries(Object.entries(object).filter(([key]) => keys.includes(key)));
	},

	// find data by id (data.id === id) in array and return or done() call
	findByID(where, id, done) {
		const index = where.findIndex(i => i.id === id);

		if (typeof done === 'function' && index !== -1) {
			return done(index, where);
		}

		return index;
	},

};